import {
  GET_USER_WALLET_REQUEST,
  GET_USER_WALLET_SUCCESS,
  GET_USER_WALLET_ERROR
} from '~gatsby-theme-autonomy/redux/actions/types'

export const getUserWalletRequest = () => {
  return {
    type: GET_USER_WALLET_REQUEST
  }
}

export const getUserWalletSuccess = () => {
  return {
    type: GET_USER_WALLET_SUCCESS
  }
}

export const getUserWalletError = error => {
  return {
    type: GET_USER_WALLET_ERROR,
    error: true,
    payload: error
  }
}

export const getUserWallet = () => async (
  dispatch,
  getState,
  { api }
) => {
  try {
    dispatch(getUserWalletRequest())

    const wallet = await api.getUserWallet()
    dispatch(getUserWalletSuccess())

    return wallet.walletPaymentSources
  } catch (error) {
    dispatch(getUserWalletError(error))
    throw error
  }
}
